/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import type { Capability } from '../../constants/capabilities';

export function getCoreCapability(): Capability {
	/* eslint-disable max-len */
	const features = [
		{
			name: 'Paragraph',
			description: 'In CKEditor 5 everything is a plugin, even paragraph writing!'
		},
		{
			name: 'Drag and Drop',
			description: 'Easily move and rearrange content within the editor.'
		},
		{
			name: 'Clipboard',
			description: 'Seamlessly cut, copy, and paste content.'
		},
		{
			name: 'Undo and Redo',
			description: 'Quickly revert or repeat previous actions.'
		},
		{
			name: 'Select All',
			description: 'Highlight all content with a single click.'
		},
		{
			name: 'Paste Plain Text',
			description: 'Insert text without any formatting.'
		},
		{
			name: 'Professionally Translated Language Packs',
			description: 'Use 40+ official translations, selectable in the \'Installation\' step.'
		},
		{
			name: 'Toolbar Configuration',
			description: 'Customize and arrange your toolbar layout. Test options in the Toolbar step or edit toolbars in the code later.'
		},
		{
			name: 'Read-only Mode',
			description: 'Prevent users from editing content under certain circumstances.'
		},
		{
			name: 'Accessibility Support',
			description: 'Incorporates features like keyboard navigation, screen reader support (ARIA attributes), and semantic output markup.'
		},
		{
			name: 'Editor SDK',
			description: 'Framework for creating custom rich-text editing solutions. Use CKEditor 5 APIs for custom feature creation.'
		}
	];
	/* eslint-enable max-len */

	return {
		name: 'Core',
		description: 'Basic features that are always enabled, regardless of the selected editor configuration.',
		features: features.map( feature => ( {
			...feature,
			plugins: [ 'CoreEditorFeatureVirtualPlugin' ],
			isSinglePluginChoice: false
		} ) ),
		isSingleFeatureChoice: false
	};
}
